<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Lottery System')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">
            <div class="mb-2 position-relative">
              <div class="multiselect-lbl">{{$t('Country')}}</div>
              <multiselect
                v-model="details.ecountry_id"
                :options="countriesList"
                :multiple="false"
                placeholder="Select country"
                track-by="name"
                label="name"
                :translate="false"
              ></multiselect>
            </div>

            <FloatingLabel v-model="details.name" label="Name" size="sm"/>
            <FloatingLabel v-model="details.n" label="All numbers in the system" size="sm"/>
            <FloatingLabel v-model="details.r" label="Number of results in system" size="sm"/>
            <FloatingLabel v-model="details.k" label="Maximum selected numbers" size="sm"/>
            <FloatingLabel v-model="details.m" label="Maximum numbers odds" size="sm"/>
            <FloatingLabel v-model="details.info" label="Info" type="textarea" size="sm"/>
            <FloatingLabel v-model="details.master_code" label="Master Code" size="sm"/>
            <FloatingLabel
              v-model="details.bet_block_offset"
              label="Bet Block Offset"
              description="Block bets with X seconds before lottery event starts"
              size="sm"
            />

            <b-form-group :label="$t('Allow Scan Next')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.allow_scan_next"
                :value="true"
                :unchecked-value="false"
              >{{$t('Allow ticket to be placed for next events')}}</b-form-checkbox>
            </b-form-group>

            <b-form-group :label="$t('Active')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.active"
                :value="true"
                :unchecked-value="false"
              >{{$t('Activate lottery system')}}</b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label="$t('Odds')"
              :description="$t('Odds for X/M (X = 1 .. M)')"
              class="grouping p-3 mb-3 mt-0"
            >
              <ListEditor
                :items="details.odds"
                :addLabel="$t('Add new odd')"
                :deleteTootltip="$t('Delete')"
                :showIndex="true"
                :m="details.m.toString()"
                :required="true"
                size="sm"
                :flex="true"
                flexWidth="140px"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Schedule')"
              :description="$t('Lotter events schedule (day of week, time of day)')"
              class="grouping p-3 mb-3 mt-0"
            >
              <DayListEditor
                :items="details.schedule"
                :addLabel="$t('Add new schedule')"
                :deleteTootltip="$t('Delete')"
                size="sm"
              />
            </b-form-group>

            <b-form-group class="my-3 pl-2">
              <b-form-checkbox
                v-model="details.automatic_processing"
                :value="true"
                :unchecked-value="false"
              >{{$t('Enable automatic result processing')}}</b-form-checkbox>
            </b-form-group>

            <FloatingLabel
              v-model="details.automatic_processing_max_amount"
              label="Automatic Processing Max Amount"
              size="sm"
            />

            <FloatingLabel
              v-model="details.automatic_processing_max_ratio"
              label="Automatic Processing Max Ratio"
              size="sm"
            />

            <b-form-group
              :label="$t('Manual Processing Alert Emails')"
              class="grouping p-3 mb-3 mt-0"
            >
              <ListEditor
                :items="details.manual_processing_alert_emails"
                :addLabel="$t('Add new email address')"
                :deleteTootltip="$t('Delete')"
                size="sm"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Liability')"
              :description="$t('Liability counters for each X/M system')"
              class="grouping p-3 mb-3 mt-0"
            >
              <ListEditor
                :items="details.liability"
                :addLabel="$t('Add new liability')"
                :deleteTootltip="$t('Delete')"
                :showIndex="true"
                :m="details.m.toString()"
                :required="true"
                size="sm"
                :flex="true"
                flexWidth="140px"
              />
            </b-form-group>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ListEditor from "@/components/ListEditor";
import DayListEditor from "@/components/DayListEditor";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "lotterySystem",
  props: ["selectedeid"],
  components: {
    ListEditor,
    DayListEditor,
    Multiselect,
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    this.$store
      .dispatch("country/fetch", {
        rowsPerPage: 500,
        page: 1,
        sortBy: ["priority"],
        sortDirection: ["ASC"]
      })
      .finally(() => {
        if (this.eid != "0" && this.eid != "") {
          this.loadData();
        } else {
          this.newId = true;
        }
      });
  },
  data: function() {
    return {
      eid: "",
      details: {
        ecountry_id: "", //	encrypted bigint	Lottery system country
        name: "", // text	Lottery system name
        n: "", // integer	All numbers in the system (1 .. N)
        k: "", //	integer	Maximum selected numbers (1 .. K)
        m: "", //	integer	Maximum numbers odds (1 .. M)
        r: "", // integer Maximum numbers results
        info: "", //	text NULL	Lottery system optional info
        master_code: "", //	integer	Lottery system master code (4 digits)
        bet_block_offset: "", //	bigint	Block bets with X seconds before lottery event starts
        allow_scan_next: false, //	boolean NULL [false]	Allow ticket to be placed for next events
        active: false, //	boolean NULL [false]	Lottery system active
        odds: [], //	bigint[]	Odds for X/K (X = 1 .. M)
        schedule: [], //	json	Lotter events schedule (day of week, time of day)
        automatic_processing: false, //	boolean NULL [false]	Enable automatic result processing
        automatic_processing_max_amount: "", //	bigint NULL	Automatic processing up to amount
        automatic_processing_max_ratio: "", //	bigint NULL	Automatic processing up to ratio
        manual_processing_alert_emails: [], //	text[] NULL	Alert email recipients
        liability: [] //	bigint[] NULL	Liability counters for each X/K system
      },
      newId: false
    };
  },
  computed: {
    countriesList() {
      return this.$store.getters["country/countries"];
    }
  },
  watch: {
    "details.m": function(newVal) {
      if (newVal) {
        if (this.details.odds.length != newVal) {
          if (this.details.odds.length < newVal) {
            for (let i = this.details.odds.length; i < newVal; i++) {
              this.details.odds.push("");
            }
          } else {
            this.details.odds = this.details.odds.slice(0, newVal);
          }
        }
        if (this.details.liability.length != newVal) {
          if (this.details.liability.length < newVal) {
            for (let i = this.details.liability.length; i < newVal; i++) {
              this.details.liability.push("");
            }
          } else {
            this.details.liability = this.details.liability.slice(0, newVal);
          }
        }
      }
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("lotterySystem/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const d = JSON.parse(JSON.stringify(this.details));
      const detailsData = {};
      let apiAction = "lotterySystem/update";
      if (this.newId) {
        apiAction = "lotterySystem/create";
      } else {
        detailsData.eid = this.eid;
      }

      detailsData.ecountry_id = d.ecountry_id;
      if (detailsData.ecountry_id)
        detailsData.ecountry_id = detailsData.ecountry_id.eid;

      detailsData.name = d.name;
      detailsData.n = parseInt(d.n);
      detailsData.k = parseInt(d.k);
      detailsData.m = parseInt(d.m);
      detailsData.r = parseInt(d.r);
      detailsData.info = d.info;
      detailsData.master_code = parseInt(d.master_code);
      detailsData.bet_block_offset = parseInt(d.bet_block_offset);
      detailsData.allow_scan_next = d.allow_scan_next;
      detailsData.active = d.active;
      detailsData.automatic_processing = d.automatic_processing;
      detailsData.automatic_processing_max_amount = parseInt(
        d.automatic_processing_max_amount
      );

      detailsData.automatic_processing_max_ratio = parseInt(
        d.automatic_processing_max_ratio
      );

      detailsData.odds = d.odds ? d.odds : [];
      for (let i = 0; i < detailsData.odds.length; i++) {
        detailsData.odds[i] = parseFloat(detailsData.odds[i]);
      }

      detailsData.schedule = d.schedule ? d.schedule : [];
      for (let i = 0; i < detailsData.schedule.length; i++) {
        detailsData.schedule[i][1] = this.hoursToMinutes(
          detailsData.schedule[i][1]
        );
        if (detailsData.schedule[i].length == 4) {
          detailsData.schedule[i][2] = this.hoursToMinutes(
            detailsData.schedule[i][2]
          );
          detailsData.schedule[i][3] = this.hoursToMinutes(
            detailsData.schedule[i][3]
          );
        }
      }
      detailsData.schedule = JSON.stringify(detailsData.schedule);

      detailsData.manual_processing_alert_emails = d.manual_processing_alert_emails
        ? d.manual_processing_alert_emails
        : [];

      detailsData.liability = d.liability ? d.liability : [];
      for (let i = 0; i < detailsData.liability.length; i++) {
        detailsData.liability[i] = parseInt(detailsData.liability[i]);
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Lottery system updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Lottery system created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.ecountry_id = r.ecountry_id;

      let tmpCountry = null;
      if (this.details.ecountry_id) {
        this.countriesList.forEach(element => {
          if (element.eid == this.details.ecountry_id) {
            tmpCountry = element;
          }
        });
      }
      this.details.ecountry_id = tmpCountry;

      this.details.name = r.name;
      this.details.n = r.n;
      this.details.k = r.k;
      this.details.m = r.m;
      this.details.r = r.r;
      this.details.info = r.info;
      this.details.master_code = r.master_code;
      this.details.bet_block_offset = r.bet_block_offset;
      this.details.allow_scan_next = r.allow_scan_next;
      this.details.active = r.active;
      this.details.odds = r.odds ? r.odds : [];

      const schedule = r.schedule ? JSON.parse(r.schedule) : [];
      if (schedule) {
        for (let i = 0; i < schedule.length; i += 1) {
          schedule[i][1] = this.minutesToHours(schedule[i][1]);
          if (schedule[i].length == 4) {
            schedule[i][2] = this.minutesToHours(schedule[i][2]);
            schedule[i][3] = this.minutesToHours(schedule[i][3]);
          }
        }
      }
      this.details.schedule = schedule;

      this.details.automatic_processing = r.automatic_processing;

      this.details.automatic_processing_max_amount =
        r.automatic_processing_max_amount;

      this.details.automatic_processing_max_ratio =
        r.automatic_processing_max_ratio;

      this.details.manual_processing_alert_emails = r.manual_processing_alert_emails
        ? r.manual_processing_alert_emails
        : [];

      this.details.liability = r.liability ? r.liability : [];
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Lottery System", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    minutesToHours(total) {
      const minutes = total % 60;
      const hours = (total - minutes) / 60;
      return (
        (hours < 10 ? `0${hours}` : hours) +
        ":" +
        (minutes < 10 ? `0${minutes}` : minutes)
      );
    },
    hoursToMinutes(total) {
      if (!total) return 0;
      const parts = total.split(":", 2);
      const hours = parseInt(parts[0]) * 60;
      const minutes = parseInt(parts[1]);
      return hours + minutes;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
